import { Form, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputNumberComponent from 'components/atoms/InputNumberComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import FormWrapper from 'components/molecules/FormWrapper';

import { IDodatekIsins, dokumentDodatekDruhCpGet, dokumentDodatekIsinPut } from 'services/dokumenty/dodatek';
import { NavyseniOstatniGet } from 'services/dokumenty/navyseni';
import { ETypPrevodu } from 'services/specialniSluzby/uePozadavky';

import { EPodTypDokumentu, ETypZpusobPredani } from 'enums/dokumentyEnums';
import { EDruhCp } from 'enums/isin/udaje/druhCp';
import { ETrueFalse } from 'enums/trueFalse';

import {
    typPrevodu,
    typPrevoduNonDltExtra,
    zbusopPredaniDfp,
    zpusobPredaniDfpProtiExtra,
    zpusobPredaniDvpDefault,
    zpusobPredaniDvpNonDltDluhopisExtra,
    zpusobPredaniDvpNonDltExtra
} from 'data/codebooks/dokumenty/zpusobPredani';
import trueFalseSelect from 'data/codebooks/trueFalseSelect';

interface IFormaCp {
    nextStep: () => void;
    prevStep: () => void;
    zadostID: number;
    dodatekData?: IDodatekIsins;
    setDotatekData: React.Dispatch<React.SetStateAction<IDodatekIsins | undefined>>;
    signingDisabled: boolean;
    isDlt: boolean;
    isCdcp: boolean;
}

const FormaCp: React.FC<IFormaCp> = ({
    nextStep,
    prevStep,
    zadostID,
    dodatekData,
    setDotatekData,
    signingDisabled,
    isDlt,
    isCdcp
}) => {
    const { dokumenty } = useContext(Context);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [, rerender] = useState<boolean>(false);
    const [zpuspredaniDVP, setZpuspredaniDVP] = useState<ETypZpusobPredani | undefined>(
        dodatekData?.zpuspredvp || undefined
    );
    const [zpuspredaniDFP, setZpuspredaniDFP] = useState<ETypZpusobPredani | undefined>(
        dodatekData?.zpuspredfp || undefined
    );
    const [zamestakcppn, setZamestakcppn] = useState<boolean>();

    const isNonDlt =
        dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.DODATEKDLT &&
        dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.NAVYSENIDLT &&
        form.getFieldValue('typprevodu') !== ETypPrevodu.PROTIABEZZAPL;

    const isDluhopis = dodatekData?.druhcp === EDruhCp.DLUHOPIS;

    useEffect(() => {
        if (
            dokumenty?.selectedZadost?.druhcp === EDruhCp.AKCIE &&
            (dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.NAVYSENI ||
                dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.NAVYSENIDLT)
        ) {
            setLoading(true);
            NavyseniOstatniGet(zadostID)
                .then(response => {
                    setZamestakcppn(response.zamestakcppn);
                })
                .finally(() => setLoading(false));
        } else if (dokumenty?.selectedZadost?.druhcp === EDruhCp.AKCIE) {
            setLoading(true);
            dokumentDodatekDruhCpGet(zadostID, EDruhCp.AKCIE)
                .then(response => {
                    setZamestakcppn(response.zamestakcppn);
                })
                .finally(() => setLoading(false));
        }

        form.setFieldsValue({
            typprevodu: dodatekData?.typprevodu,
            zpuspredaniDVP: dodatekData?.zpuspredvp,
            vicupisovatelu:
                typeof dodatekData?.vicupisovatelu === 'boolean' ? String(dodatekData?.vicupisovatelu) : undefined
        });
        rerender(pv => !pv);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LoadingWrapper loading={loading}>
            {dodatekData && (
                <FormWrapper
                    outForm={form}
                    onFinish={values => {
                        setLoading(true);
                        const vals = {
                            ...dodatekData
                        };
                        delete vals.vicupisovatelu;
                        delete vals.zpuspredvp;
                        delete vals.zpuspredfp;
                        dokumentDodatekIsinPut(zadostID, {
                            ...vals,
                            typprevodu: values.typprevodu,
                            /* ...(values.dodatekdvp && {
                                dodatekdvp: values.dodatekdvp === 'true'
                            }), */
                            ...(zpuspredaniDVP && {
                                zpuspredvp: zpuspredaniDVP
                            }),
                            ...(zpuspredaniDFP && {
                                zpuspredfp: zpuspredaniDFP
                            }),
                            ...(values.vicupisovatelu && {
                                vicupisovatelu: values.vicupisovatelu === ETrueFalse.TRUE
                            }),
                            ...(values.pocetcpvn && {
                                pocetcpvn: values.pocetcpvn
                            })
                        })
                            .then(() => {
                                setDotatekData({
                                    ...vals,
                                    /*  ...(values.dodatekdvp && {
                                        dodatekdvp: values.dodatekdvp === 'true'
                                    }), */
                                    typprevodu: values.typprevodu,
                                    ...(zpuspredaniDVP && {
                                        zpuspredvp: zpuspredaniDVP
                                    }),
                                    ...(zpuspredaniDFP && {
                                        zpuspredfp: zpuspredaniDFP
                                    }),
                                    ...(values.vicupisovatelu && {
                                        vicupisovatelu: values.vicupisovatelu === ETrueFalse.TRUE
                                    }),
                                    ...(values.pocetcpvn && {
                                        pocetcpvn: values.pocetcpvn
                                    })
                                });
                                setLoading(false);
                                setTimeout(() => {
                                    nextStep();
                                }, 0);
                            })
                            .catch(() => setLoading(false));
                    }}
                >
                    <Row>
                        <Paragraph
                            text="*"
                            style={{
                                color: '#ff4d4f',
                                fontSize: 23,
                                position: 'relative',
                                top: 4,
                                marginRight: 2
                            }}
                        />
                        <Title level={5} text="DOKUMENT_DODATEK_CP_TITLE" />
                    </Row>
                    <Paragraph
                        text="DOKUMENT_DODATEK_CP_TEXT"
                        style={{
                            display: 'block',
                            marginBottom: 10
                        }}
                    />
                    <SelectComponent
                        name="typprevodu"
                        isFormItem={true}
                        data={
                            (zamestakcppn && isCdcp) || dodatekData.zmenregi
                                ? [
                                      {
                                          labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_BEZZAPLACENI',
                                          value: ETypPrevodu.BEZZAPLACENI
                                      }
                                  ]
                                : [...typPrevodu, ...(!isDlt ? typPrevoduNonDltExtra : [])]
                        }
                        defaultValue={dodatekData.typprevodu}
                        onChange={() => {
                            /*    if (val === ETypPrevodu.PROTIABEZZAPL) {
                                 setZpuspredaniDVP(ETypZpusobPredani.PARSYST);
                                setZpuspredaniDFP(ETypZpusobPredani.MD);
                                  form.setFieldsValue({
                                    zpuspredaniDVP: ETypZpusobPredani.PARSYST,
                                    zpuspredaniDFP: ETypZpusobPredani.MD
                                }); 
                            } else {*/
                            setZpuspredaniDVP(undefined);
                            setZpuspredaniDFP(undefined);
                            //   }
                            setTimeout(() => {
                                form.resetFields(['zpuspredaniDVP', 'zpuspredaniDFP']);
                            }, 100);
                            rerender(pv => !pv);
                        }}
                        disabled={signingDisabled}
                    />
                    {(form.getFieldValue('typprevodu') === ETypPrevodu.PROTIZAPLACENI ||
                        form.getFieldValue('typprevodu') === ETypPrevodu.PROTIABEZZAPL) && (
                        <SelectComponent
                            name="zpuspredaniDVP"
                            labelParagraph="DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_DVP"
                            isFormItem={true}
                            data={[
                                ...zpusobPredaniDvpDefault,
                                ...(isNonDlt ? zpusobPredaniDvpNonDltExtra : []),
                                ...(dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.DODATEKDLT &&
                                dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.NAVYSENIDLT &&
                                form.getFieldValue('typprevodu') !== ETypPrevodu.BEZZAPLACENI &&
                                isDluhopis
                                    ? zpusobPredaniDvpNonDltDluhopisExtra
                                    : [])
                            ]}
                            disabled={signingDisabled}
                            defaultValue={zpuspredaniDVP}
                            onChange={val => {
                                setZpuspredaniDVP(val);
                                if (
                                    form.getFieldValue('typprevodu') === ETypPrevodu.PROTIABEZZAPL &&
                                    val !== ETypZpusobPredani.BURZA
                                ) {
                                    setZpuspredaniDFP(val);
                                    form.setFieldsValue({
                                        zpuspredaniDFP: val
                                    });
                                }
                            }}
                        />
                    )}
                    {form.getFieldValue('zpuspredaniDVP') === ETypZpusobPredani.BURZA && (
                        <InputNumberComponent
                            name="pocetcpvn"
                            label="DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_BURZA_OBJEM"
                            infoTooltipText="DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_BURZA_OBJEM_TOOLTIP"
                            disabled={signingDisabled}
                            initialValue={dodatekData?.pocetcpvn}
                            precision={0}
                        />
                    )}
                    {form.getFieldValue('typprevodu') === ETypPrevodu.BEZZAPLACENI &&
                        dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.DODATEKDLT &&
                        dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.NAVYSENIDLT && (
                            <SelectComponent
                                name="vicupisovatelu"
                                labelParagraph="DOKUMENT_DODATEK_CP_SPUSOB_VICUPISOVATELU"
                                isFormItem={true}
                                data={trueFalseSelect}
                                defaultValue={
                                    typeof dodatekData.vicupisovatelu === 'boolean'
                                        ? String(dodatekData.vicupisovatelu)
                                        : undefined
                                }
                                disabled={signingDisabled}
                                onChange={() => {
                                    setZpuspredaniDFP(undefined);
                                    form.setFieldsValue({
                                        zpuspredaniDFP: undefined
                                    });
                                }}
                            />
                        )}
                    {(form.getFieldValue('typprevodu') === ETypPrevodu.BEZZAPLACENI ||
                        form.getFieldValue('typprevodu') === ETypPrevodu.PROTIABEZZAPL) && (
                        <SelectComponent
                            name="zpuspredaniDFP"
                            labelParagraph="DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ_DFP"
                            isFormItem={true}
                            data={[
                                ...zbusopPredaniDfp,
                                ...(dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.DODATEKDLT &&
                                dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.NAVYSENIDLT &&
                                (!form.getFieldValue('vicupisovatelu') ||
                                    form.getFieldValue('vicupisovatelu') !== 'true') &&
                                form.getFieldValue('typprevodu') !== ETypPrevodu.PROTIABEZZAPL
                                    ? zpusobPredaniDfpProtiExtra
                                    : [])
                            ]}
                            disabled={
                                signingDisabled ||
                                (form.getFieldValue('typprevodu') === ETypPrevodu.PROTIABEZZAPL &&
                                    form.getFieldValue('zpuspredaniDVP') !== ETypZpusobPredani.BURZA)
                            }
                            defaultValue={zpuspredaniDFP}
                            onChange={val => {
                                setZpuspredaniDFP(val);
                                rerender(pv => !pv);
                            }}
                        />
                    )}
                    {/* !isDlt && (
                        <SelectComponent
                            labelParagraph="DODATEK_PREJIST_PRIKAZ"
                            name="dodatekdvp"
                            isFormItem={true}
                            data={trueFalseSelect}
                            defaultValue={
                                typeof dodatekData.dodatekdvp === 'boolean' ? String(dodatekData.dodatekdvp) : undefined
                            }
                            disabled={signingDisabled}
                        />
                    )
                    {form.getFieldValue('typprevodu') && (
                        <SelectComponent
                            name="zpuspredani"
                            labelParagraph="DOKUMENT_DODATEK_CP_SPUSOB_PRIKAZ"
                            isFormItem={true}
                            data={[
                                ...(dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.DODATEKDLT &&
                                dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.NAVYSENIDLT
                                    ? [
                                          {
                                              labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_CDCP',
                                              value: ETypZpusobPredani.CDCP
                                          }
                                      ]
                                    : []),
                                ...(dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.DODATEKDLT ||
                                dokumenty?.selectedZadost?.podtyp === EPodTypDokumentu.NAVYSENIDLT ||
                                form.getFieldValue('typprevodu') !== ETypPrevodu.PROTIZAPLACENI
                                    ? [
                                          {
                                              labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_MD',
                                              value: ETypZpusobPredani.MD
                                          }
                                      ]
                                    : []),
                                ...(dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.DODATEKDLT &&
                                dokumenty?.selectedZadost?.podtyp !== EPodTypDokumentu.NAVYSENIDLT &&
                                form.getFieldValue('typprevodu') !== 'BEZZAPLACENI'
                                    ? [
                                          {
                                              labelcz: 'DOKUMENT_DODATEK_CP_SPUSOB_ZPUSOBPREDANI_PARSYST',
                                              value: ETypZpusobPredani.PARSYST
                                          }
                                      ]
                                    : [])
                            ]}
                            disabled={signingDisabled}
                            defaultValue={zpuspredani}
                            onChange={val => setZpuspredani(val)}
                        />
                    )}*/}
                    <Row className="button-row">
                        <ButtonComponent buttontext="ZPET" onClick={() => prevStep()} id="isinZpetBtn" type="default" />
                        <ButtonComponent buttontext="POKRACOVAT" htmlType="submit" id="isinPokracovatBtn" />
                    </Row>
                </FormWrapper>
            )}
        </LoadingWrapper>
    );
};

export default FormaCp;
